import { Dispatch } from 'redux';
import { httpError, blob, fetchGet } from 'common';
const apiUri: string = process.env.REACT_APP_API_URI as string;

export const taxMapsExportService = (
  searchId: number,
  middlename: string,
  imageId: number,
  token: string,
  format: string,
  dispatch: Dispatch,
) =>
  fetchGet(
    `${apiUri}/TaxMaps/${searchId}/${middlename}/${imageId}/${format}`,
    token,
  )
    .then(httpError(dispatch))
    .then(blob);
